import { render, staticRenderFns } from "./NewSource.vue?vue&type=template&id=04168fbe&"
import script from "./NewSource.vue?vue&type=script&lang=js&"
export * from "./NewSource.vue?vue&type=script&lang=js&"
import style0 from "./NewSource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports